<template>
  <v-dialog
    :value="control"
    max-width="1000"
    persistent
    class="impressao"
  >
    <div class="ui-dialog-impressao" v-if="info" :class="this.$vuetify.theme.dark ? 'bg-black' : 'bg-white'">
      <div class="ui-dialog-top-impressao impressao__titulo text-uppercase">
        {{info.titulo}}
      </div>
      <div class="ui-dialog-content">
        <v-row no-gutters justify="space-between" class="mt-1">
          <v-col
            cols="12"
            sm="12"
            class="impressao__page pl-2 pr-2"
          >
            <div id="print" class="v-application direction_row">
              <div class="impressao__footer impressao__footer_hr text-center">
                <p class="impressao__footer_text">Emitido através da plataforma <b>StartIn</b> em {{$root.Formatter.formatDate(datetime, 'L')}} {{$root.Formatter.formatDate(datetime, 'HH:mm:ss')}}</p>
              </div>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <table class="impressao__header">
                        <tr>
                          <td width="50%" align="left">
                            <img class="impressao__logo" src="@assets/img/logo.png" alt="StartIn">
                          </td>
                        </tr>
                      </table>
                      <table class="impressao__conteudo" style="line-height: 3;">
                        <tbody>
                          <tr>
                            <td class="impressao__conteudo_text">
                              <component :is="info.component" :data="info.data" :headers="info.headers" :title="info.titulo"></component>
                            </td>
                          </tr>
                          <!-- <tr v-if="info.texto">
                            <td class="impressao__conteudo_text" v-html="info.texto">
                            </td>
                          </tr> -->
                        </tbody>
                      </table>
                      <table class="impressao__data">
                        <tbody>
                          <tr>
                            <td class="text-right">
                              <p class="mb-1 impressao__fonte text-capitalize" :class="this.$vuetify.theme.dark ? 'text-white' : 'text-black'">
                                {{$root.Formatter.formatDate(hoje, 'dddd, LL')}}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td>
                      <div class="impressao__footer-space"></div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters justify="space-between" class="mt-4">
          <v-btn color="gray" @click="close()">
            Fechar
          </v-btn>
          <v-btn :disabled="loading" :loading="loading" color="primary" class="v-btn" @click="print()">
            Imprimir
          </v-btn>
        </v-row>
      </div>
    </div>
  </v-dialog>
</template>

<script>
// import Api from '@API'
import Printd from 'printd'
import moment from 'moment'

export default {
  props: ['control'],
  data () {
    return {
      info: this.$root.printerControl.data,
      showOnPrint: false,
      hoje: new Date(),
      datetime: new Date(),
      loading: false,
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      formularioLeft: {
        display: 'table',
        borderCollapse: 'separate',
        boxSizing: 'border-box',
        textIndent: 'initial',
        borderSpacing: '2px',
        borderColor: 'grey',
        borderRight: 'solid 1px #bbb',
        borderBottom: 'solid 1px #bbb',
        padding: 0,
        fontSize: '11px',
        width: '320px',
        height: '100px',
        float: 'left'
      },
      formularioRight: {
        display: 'table',
        borderCollapse: 'separate',
        boxSizing: 'border-box',
        textIndent: 'initial',
        borderSpacing: '2px',
        borderColor: 'grey',
        borderRight: 'solid 1px #bbb',
        borderBottom: 'solid 1px #bbb',
        padding: 0,
        fontSize: '11px',
        width: '320px',
        height: '100px',
        float: 'right'
      },
      formularioTd: {
        borderSpacing: 0,
        padding: '1px 10px 10px 3px',
        lineHeight: '13px',
        borderTop: 'solid 1px #bbb',
        borderLeft: 'solid 1px #bbb',
        verticalAlign: 'top'
      },
      h7: {
        borderTop: 'solid 1px #bbb',
        borderLeft: 'solid 1px #bbb',
        height: '100px'
      }
    }
  },
  created () {
  },
  watch: {
    control () {
      this.hoje = new Date()
      this.datetime = new Date()
      this.info = this.$root.printerControl.data
    }
  },
  methods: {
    toggleShowOnPrint () {
      this.datetime = new Date()
      this.showOnPrint = !this.showOnPrint
    },
    async print () {
      this.loading = true
      await this.toggleShowOnPrint()
      const d = new Printd()

      let styles = [
        `
          body {
            overflow: hidden;
            font-family: "Arial", sans-serif !important;
          }
          p, strong, b, small, span, q, i {
            color: #000!important;
            font-size: 11px;
            line-height: 11px;
          }
          .v-application {
            font-family: "Arial", sans-serif !important;
          }
        `,
        `
          .direction_row {
            flex-direction: column;
          }
          .impressao__header {
            width: 100%;
            color: #000!important;
          }
          .impressao__page {
            max-height: 25em;
            overflow: auto;
            color: #000!important;
          }
          .impressao__logo {
            max-width: 60%;
            color: #000!important;
          }
          .impressao__fonte, .impressao__fonte p {
            font-size: 11px;
            line-height: 11px;
            color: #000!important;
          }
          .impressao__footer {
            bottom: 0;
            position: fixed;
            width: 100%;
            display: none;
          }
          .impressao__footer_text {
            color: #d0d0d0;
            font-size: 11px;
            padding-top: 5px;
          }
          .impressao__footer_hr {
            border-top: 1px solid #d0d0d0;
            margin-bottom: 10px;
          }
          .impressao__assinatura {
            width: 45%;
            float: left;
          }
          .impressao__data {
            margin: 3em 0px;
            text-align: right;
            width: 100%;
          }
          .impressao__conteudo {
            width: 100%;
          }
          .impressao__conteudo_text, .impressao__conteudo_text p {
            color: #000!important;
            font-size: 13px;
            line-height: 20px;
            text-align: justify;
            word-break: break-word;
          }
          .impressao__break {
            page-break-after: always;
          }
          .impressao__footer, .impressao__footer-space {
            height: 2em;
          }
          .table_paciente_contrato td {
            border: 1px solid rgb(221, 221, 221);
            padding: 5px;
          }
          @media screen {
            .impressao__footer {
              display: none;
            }
          }
          @media print {
            thead {display: table-header-group;}
            tfoot {display: table-footer-group;}
            button {display: none;}
            body {margin: 0;}
            * {
              color: #000!important;
            }
            th {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
            }
            td {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
            }
            p {
              widows: 3;
            }

            .impressao__footer {
              display: block;
            }
          }
          @page {
            size: A4 landscape !important;
            margin: 12mm;
          }
        `,
        'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
        'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css'
      ]

      if (this.info.css) {
        styles.push(this.info.css)
      }

      let documento = document.getElementById('print')
      await d.print(documento, styles)
      await this.toggleShowOnPrint()
      this.loading = false
    },
    close () {
      this.$root.Printer.closeDialog(this)
    },
    validaIdade (paciente) {
      var idade = Math.floor(moment(new Date()).diff(moment(paciente.usu_data_nascimento), 'years', true))
      return idade
    },
    verificaResponsavel (responsaveis, tipo) {
      var result = responsaveis.filter(item => {
        return item.resp_tipo === tipo
      })
      if (result && result.length > 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.impressao__page ol, .impressao__page ul {
  list-style: auto;
}
.direction_row {
  flex-direction: column;
}
.impressao__header {
  width: 100%;
  color: rgba(0,0,0,.87)!important;
}
.impressao__page {
  max-height: 25em;
  overflow: auto;
  color: rgba(0,0,0,.87)!important;
}
.impressao__logo {
  max-width: 60%;
  color: rgba(0,0,0,.87)!important;
}
.impressao__fonte, .impressao__fonte p {
  font-size: 11px;
  line-height: 11px;
}
.impressao__footer {
  bottom: 0;
  position: fixed;
  width: 100%;
  display: none;
}
.impressao__footer_text {
  color: #d0d0d0;
  font-size: 11px;
  padding-top: 5px;
}
.impressao__footer_hr {
  border-top: 1px solid #d0d0d0;
  margin-bottom: 10px;
}
.impressao__data {
  margin: 3em 0px;
  text-align: right;
  width: 100%;
}
.impressao__conteudo {
  width: 100%;
}
.impressao__conteudo_text, .impressao__conteudo_text p {
  color: rgba(0,0,0,.87)!important;
  font-size: 13px;
  line-height: 20px;
  text-align: justify;
  word-break: break-word;
}
.impressao__break {
  page-break-after: always;
}
.impressao__footer, .impressao__footer-space {
  height: 2em;
}
@media screen {
  .impressao__footer {
    display: none;
  }
}
@media print {
  thead {display: table-header-group;}
  tfoot {display: table-footer-group;}
  button {display: none;}
  body {margin: 0;}

  .impressao__footer {
    display: block;
  }
}
/* @page {
  size: A4 landscape !important;
  margin: 12mm;
} */
</style>



// WEBPACK FOOTER //
// src/components/Printer.vue